import { Component } from '../core/smpl-components.js'
import { Eyes } from '../modules/eyes.js'

// -----------------------------------------------------------------------------
// Berg eyes — the character's eyes follow the cursor and blink now and then.
// All the behaviour lives in modules/eyes.js; this only ties it to the markup.
// Selector: `.js-berg-eyes`, wrapping an svg with `.eye` groups.
// -----------------------------------------------------------------------------
export default class extends Component {
	mount() {
		this.eyes = new Eyes(this.element)
		this.eyes.start()

		if (this.options.debug) window.eyes = this.eyes.set
	}

	unmount() {
		this.eyes.destroy()
		if (window.eyes === this.eyes.set) delete window.eyes
		this.eyes = null
	}
}
